import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

const ConfirmCheckInOut = ({ open, onClose, onConfirm, actionType }) => {
  const actionText = actionType === "checkin" ? "Check-In" : "Check-Out";
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Confirm {actionText}</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to <strong>{actionText.toLowerCase()}</strong>? This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">Cancel</Button>
        <Button onClick={onConfirm} color={actionType === "checkin" ? "success" : "error"} variant="contained">
          Yes, {actionText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmCheckInOut;
